import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c056fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cont-nav" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  border: "1",
  bordercolor: "#ccc"
}
const _hoisted_5 = { class: "ybtitle-tooltip" }
const _hoisted_6 = ["onMouseleave", "onMouseenter"]
const _hoisted_7 = {
  border: "1",
  id: "scrollTable",
  ref: "scrollTable"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ybtitle-tooltip" }
const _hoisted_10 = ["onMouseleave", "onMouseenter"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoubleLeftOutlined = _resolveComponent("DoubleLeftOutlined")!
  const _component_DoubleRightOutlined = _resolveComponent("DoubleRightOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("section", null, [
      _createElementVNode("nav", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: i,
            class: _normalizeClass({ active: tag.value === _ctx.activeTagVal }),
            onClick: ($event: any) => (_ctx.checkTag(tag))
          }, _toDisplayString(tag.label), 11, _hoisted_2))
        }), 128))
      ])
    ]),
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.spinning
    }, {
      default: _withCtx(() => [
        ((_ctx.data || []).length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _withDirectives(_createElementVNode("div", {
                class: "left-icon",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToTarget('left')))
              }, [
                _createVNode(_component_DoubleLeftOutlined)
              ], 512), [
                [_vShow, _ctx.leftIconShow]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "right-icon",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToTarget('right')))
              }, [
                _createVNode(_component_DoubleRightOutlined)
              ], 512), [
                [_vShow, _ctx.rightIconShow]
              ]),
              _createElementVNode("div", {
                id: "myTableBlock",
                ref: "myTableBlock",
                onScroll: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleScroll()))
              }, [
                _createElementVNode("table", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("th", {
                        class: _normalizeClass([{ 'font-bold': !item.indentStep && item.key !== 'OpinionType' }, 'indent'+item.indentStep ])
                      }, [
                        _createElementVNode("span", null, [
                          _createVNode(_component_a_tooltip, {
                            placement: "topLeft",
                            visible: _ctx.overflow[item.title + i],
                            align: {
                      offset: [0, 4]
                    },
                            mouseEnterDelay: 0.4,
                            getPopupContainer: _ctx.getPopupContainer
                          }, {
                            title: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "overflow",
                                onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(item.title, i)), ["stop"]),
                                onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow($event, item.title, i)), ["stop"]),
                                href: "javascript:void(0)"
                              }, _toDisplayString(item.title), 41, _hoisted_6)
                            ]),
                            _: 2
                          }, 1032, ["visible", "mouseEnterDelay", "getPopupContainer"])
                        ])
                      ], 2)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("table", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (td, t) => {
                        return (_openBlock(), _createElementBlock("td", { key: t }, [
                          (item.key === 'OpinionType')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                _createVNode(_component_a_tooltip, {
                                  placement: "topLeft",
                                  visible: _ctx.overflow[item.key + t],
                                  align: {
                      offset: [0, 4]
                    },
                                  mouseEnterDelay: 0.4,
                                  getPopupContainer: _ctx.getPopupContainer
                                }, {
                                  title: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getOpinion(td[item.key])), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: "overflow",
                                      onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(item.key, t)), ["stop"]),
                                      onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow($event, item.key, t)), ["stop"]),
                                      href: "javascript:void(0)"
                                    }, _toDisplayString(_ctx.getOpinion(td[item.key])), 41, _hoisted_10)
                                  ]),
                                  _: 2
                                }, 1032, ["visible", "mouseEnterDelay", "getPopupContainer"])
                              ]))
                            : (item.key === 'time')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(td[item.key]), 1))
                              : (item.key === '')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                                : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                    (_ctx.activeTagVal > 3)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(td[item.key] && String(td[item.key]) !== "0"
                    ? (td[item.key] - 0).toFixed(2) + '%'
                    : "—"), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(Math.abs(td[item.key]) >= 100000000
                    ? (td[item.key] / 100000000).toFixed(2) + "亿"
                    : Math.abs(td[item.key]) >= 10000
                    ? (td[item.key] / 10000).toFixed(2) + "万"
                    : td[item.key] && String(td[item.key]) !== "0"
                    ? (td[item.key] - 0).toFixed(2)
                    : "—"), 1))
                                  ]))
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ], 512)
              ], 544)
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_16, [
              _createVNode(_component_Nodata, {
                nodatadesc: _ctx.itemdata.title
              }, null, 8, ["nodatadesc"])
            ]))
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}